import * as dropIn from 'braintree-web-drop-in';
import { ErrorType, PaymentError } from '../../common/error';

export class BraintreeService {
  constructor(private readonly dropIn: dropIn.Dropin) {}

  async requestPaymentMethod() {
    try {
      return await this.dropIn.requestPaymentMethod();
    } catch (e) {
      throw new PaymentError(ErrorType.BRAINTREE, (e as Error).message);
    }
  }

  updatePrice(price: string, label: string) {
    (this.dropIn as any).updateConfiguration('paypal', 'amount', price);
    (this.dropIn as any).updateConfiguration('googlePay', 'transactionInfo', {
      currencyCode: 'EUR',
      totalPrice: price,
      totalPriceStatus: 'FINAL',
    });
    (this.dropIn as any).updateConfiguration('applePay', 'paymentRequest', {
      total: {
        amount: price,
        label: label,
      },
    });
  }

  async teardown() {
    await this.dropIn.teardown();
  }
}
